module.exports = __webpack_public_path__ + "img/check-red-1.bd86f05a.png";